import { useEffect, useState } from 'react'

const useScreenDimensions = () => {
  const [screenDimensions, setScreenDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  const updateScreenDimensions = () => {
    setScreenDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }

  useEffect(() => {
    updateScreenDimensions()
    window.addEventListener('resize', updateScreenDimensions)

    return () => {
      window.removeEventListener('resize', updateScreenDimensions)
    }
  }, [])

  return screenDimensions
}

export default useScreenDimensions
